$(window).on('load', () => {
    $('body').css('opacity', 1);
})

if($(window).width() <=  767) {
    if($('#js-pdp-slider')) {
        let $slider = $('#js-pdp-slider'),
            $tools = $slider.siblings('.js-slider-tools');

        $slider.on('beforeChange', function() {
            $tools.hide();
        });

        $(window).on('load resize', positionSliderTools);

        $slider.on('init reInit afterChange', function(event, slick, currentSlide) {
            positionSliderTools();

            var i = (typeof currentSlide === 'number' ? currentSlide : slick.currentSlide) + 1;
            $tools.find('.slick-current').text(i);
            $tools.find('.slick-total').text(slick.slideCount);
        });

        $slider.slick({
            autoplay: false,
            infinite: true,
            speed: 750,
            arrows: true,
            prevArrow: $tools.find('.js-slider-prev'),
            nextArrow: $tools.find('.js-slider-next'),
            dots: false,
            fade: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            touchThreshold: 1000,
            swipeToSlide: true,
            pauseOnHover: false,
            pauseOnFocus: false
        });

        // reposition arrows and counter depending on image height (only mobile)
        function positionSliderTools() {
            // Find currently visible image
            const $currentImg = $slider.find('.slick-slide.slick-current').first();

            if ($currentImg.length) {
                const imgHeight = $currentImg.height();
                $tools.css({
                    top: imgHeight - 40 + 'px',
                    position: 'absolute'
                });

                $tools.fadeIn(250);
            }
        }
    }

    function toggleMenu() {
        const $header = $('#js-header');
        const $toggle = $('#js-toggle-menu');

        $toggle.on('click', (e) => {
            e.preventDefault();
            $('html, body').toggleClass('is-locked');
            $(e.currentTarget).toggleClass('is-open');

            $('#js-menu').toggleClass('is-shown');
            $header.toggleClass('is-open');
            $header.addClass('is-fixed');
        });

        $('.js-open-cart').on('click', (e) => {
            $('html, body').removeClass('is-locked');
            $('#js-menu').removeClass('is-shown');
            $header.removeClass('is-open is-fixed');
        });
    }

    toggleMenu();

    if($('#js-index-product-mobile')) {
        let $slider = $('#js-index-product-mobile'),
            $tools = $slider.siblings('.js-slider-tools');

        $slider.on('init reInit afterChange', function(event, slick, currentSlide) {
            positionSliderTools();

            var i = (typeof currentSlide === 'number' ? currentSlide : slick.currentSlide) + 1;
            $tools.find('.slick-current').text(i);
            $tools.find('.slick-total').text(slick.slideCount);
        });

        $slider.on('beforeChange', function() {
            $tools.hide();
        });

        $(window).on('load resize', positionSliderTools);

        $slider.slick({
            autoplay: false,
            infinite: true,
            speed: 750,
            arrows: true,
            prevArrow: $tools.find('.js-slider-prev'),
            nextArrow: $tools.find('.js-slider-next'),
            dots: false,
            fade: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            touchThreshold: 1000,
            swipeToSlide: true,
            pauseOnHover: false,
            pauseOnFocus: false
        });

        // reposition arrows and counter depending on image height (only mobile)
        function positionSliderTools() {
            // Find currently visible image
            const $currentImg = $slider.find('.slick-slide.slick-current').first();

            if ($currentImg.length) {
                const imgHeight = $currentImg.height();
                $tools.css({
                    top: imgHeight - 30 + 'px',
                    position: 'absolute'
                });

                $tools.fadeIn(250);
            }
        }
    }
}